<script>
  export let temperature;
  export let freezer = false;

  function getHeight() {
    let min = -10;
    let max = 20;

    if (freezer) {
      min = -20;
      max = 5;
    }

    let height = ((temperature - min) / (max - min)) * 100 + '%';

    return height;
  }

  function getColor() {
    let normalMin = 0;
    let normalMax = 4;
    let badMin = -3;
    let badMax = 8;

    if (freezer) {
      normalMin = -10;
      normalMax = -8;
      badMin = -14;
      badMax = -4;
    }

    if (temperature >= normalMin && temperature <= normalMax) return '🟢';
    else if (temperature <= badMin || temperature >= badMax) return '🔴';
    else return '🟡';
  }
</script>

<div class="wrapper">
  <div class="termometer">
    <div class="temperatureleft" style="height:0" data-value={getColor()} />
    <div class="temperature" style="height:{getHeight()}" data-value="{temperature}°C" />
    <div class="graduations" />
  </div>
</div>

<style>
  .wrapper {
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .termometer {
    width: 25px;
    background: #38383f;
    height: 240px;
    position: relative;
    border: 9px solid #2a2a2e;
    border-radius: 20px;
    z-index: 1;
    margin-bottom: 50px;
  }

  .termometer:before,
  .termometer:after {
    position: absolute;
    content: '';
    border-radius: 50%;
  }

  .termometer:after {
    transform: translateX(-50%);
    width: 50px;
    height: 50px;
    background-color: #3dcadf;
    bottom: -41px;
    border: 9px solid #2a2a2e;
    z-index: -3;
    left: 50%;
  }

  .termometer .graduations {
    height: 59%;
    top: 20%;
    width: 50%;
  }

  .termometer .graduations,
  .termometer .graduations:before {
    position: absolute;
    border-top: 2px solid rgba(0, 0, 0, 0.5);
    border-bottom: 2px solid rgba(0, 0, 0, 0.5);
  }

  .termometer .graduations:before {
    content: '';
    height: 34%;
    width: 100%;
    top: 32%;
  }

  .termometer .temperature {
    bottom: 0;
    background: linear-gradient(#f17a65, #3dcadf) no-repeat bottom;
    width: 100%;
    border-radius: 20px;
    background-size: 100% 240px;
    transition: all 0.2s ease-in-out;
  }

  .termometer .temperature,
  .termometer .temperature:before,
  .termometer .temperature:after {
    position: absolute;
  }

  .termometer .temperature:before {
    content: attr(data-value);
    background: rgba(0, 0, 0, 0.7);
    color: white;
    z-index: 2;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 2em;
    line-height: 1;
    transform: translateY(50%);
    left: calc(100% + 1em / 1.5);
    top: calc(-1em + 5px - 5px * 2);
  }

  .termometer .temperature:after {
    content: '';
    border-top: 0.4545454545em solid transparent;
    border-bottom: 0.4545454545em solid transparent;
    border-right: 0.6666666667em solid rgba(0, 0, 0, 0.7);
    left: 100%;
    top: calc(-1em / 2.2 + 5px);
  }

  /* LEFT */
  .termometer .temperatureleft:after {
    content: attr(data-value);
    color: white;
    z-index: 2;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 2em;
    line-height: 1;
    margin-left: -80px;
  }
</style>
